/**
 * @Author: Klaudie <klaudie@foxprofi.cz>
 */

import { ReactNode } from 'react'
import { usePermissions } from '@/hooks/useAuth'

interface PermissionGuardProps {
  moduleSlug: string
  functionSlug: string
  children: ReactNode
  fallback?: ReactNode
}

/**
 * Komponenta pro podmíněné zobrazení obsahu podle oprávnění
 * 
 * @example
 * <PermissionGuard moduleSlug="admin" functionSlug="manage_users">
 *   <Button>Vytvořit uživatele</Button>
 * </PermissionGuard>
 */
export function PermissionGuard({
  moduleSlug,
  functionSlug,
  children,
  fallback = null,
}: PermissionGuardProps) {
  const { canAccess } = usePermissions()

  if (!canAccess(moduleSlug, functionSlug)) {
    return <>{fallback}</>
  }

  return <>{children}</>
}
